import { useQuery } from "@tanstack/react-query";
import { CACHE_FRESH_TIME, CACHE_RETENTION_TIME } from "./constants";
const normalizeParam = (value) => value !== undefined && value !== "" ? value : undefined;
const getDriverQuery = ({ countryCode, unitId, divisionId, hasForecast, }) => {
    const normalizedUnitId = normalizeParam(unitId);
    const normalizedDivisionId = normalizeParam(divisionId);
    const queryString = [
        normalizedUnitId !== undefined
            ? `unitId=${encodeURIComponent(normalizedUnitId)}`
            : "",
        normalizedDivisionId !== undefined
            ? `divisionId=${encodeURIComponent(normalizedDivisionId)}`
            : "",
        hasForecast !== undefined
            ? `hasForecast=${encodeURIComponent(hasForecast)}`
            : "",
    ]
        .filter(Boolean)
        .join("&");
    return {
        queryKey: [
            "country-drivers",
            countryCode,
            normalizedUnitId,
            normalizedDivisionId,
            hasForecast,
        ],
        url: `/driver/country/${countryCode}${queryString ? `?${queryString}` : ""}`,
    };
};
const normalizeDrivers = (drivers) => (Array.isArray(drivers) ? drivers : []).map((driver) => ({
    ...driver,
    mappings: Array.isArray(driver.mappings) ? driver.mappings : [],
}));
const fetchDrivers = async (fetchApi, url, signal) => {
    const res = await fetchApi.jsonInJsonOut(url, { signal });
    return normalizeDrivers(res?.payload);
};
export const useGetDrivers = ({ fetchApi, countryCode, unitId, divisionId, hasForecast, enabled = true, }) => {
    const { queryKey, url } = getDriverQuery({
        countryCode,
        unitId,
        divisionId,
        hasForecast,
    });
    const { data, refetch, isLoading, isFetching, error } = useQuery({
        queryKey,
        enabled,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        staleTime: CACHE_FRESH_TIME,
        gcTime: CACHE_RETENTION_TIME,
        queryFn: ({ signal }) => fetchDrivers(fetchApi, url, signal),
    });
    const loading = enabled && (isLoading || isFetching);
    return {
        data: data === undefined ? null : data,
        loading,
        error,
        refetch,
    };
};
export const prefetchDrivers = (queryClient, fetchApi, params) => {
    const { queryKey, url } = getDriverQuery(params);
    void queryClient.prefetchQuery({
        queryKey,
        staleTime: CACHE_FRESH_TIME,
        gcTime: CACHE_RETENTION_TIME,
        queryFn: ({ signal }) => fetchDrivers(fetchApi, url, signal),
    });
};
//# sourceMappingURL=driversApi.js.map